export class Vraag {
  constructor(public id: number,  public taakid: string) { }
}